var map = {
	"./icon_agent.png": "6c3e",
	"./icon_agent_en.png": "818d",
	"./icon_agent_es.png": "50c6",
	"./icon_agent_hk.png": "074e",
	"./icon_agent_pt.png": "80a3",
	"./icon_agent_tr.png": "80ab"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6b7f";